module.exports = __webpack_public_path__ + "img/Caravaggio_story_end.5ed0c0c7.png";